import * as trace from 'owa-trace';
import datapoints from 'mini-mail-bootstrap/lib/datapoints';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import logInitialRenderPerfDatapoint from 'mini-common-utils/lib/utils/logInitialRenderPerfDatapoint';
import { logUsage } from 'owa-analytics';

const logDatapointsAfterInitialRender = () => {
    try {
        logInitialRenderPerfDatapoint({ datapointName: 'InitialRenderComplete' });

        const userConfiguration = getUserConfiguration();
        const sortOrderFromOptions =
            userConfiguration &&
            userConfiguration.UserOptions &&
            userConfiguration.UserOptions.ConversationSortOrderReact;

        if (sortOrderFromOptions) {
            const {
                name: eventName,
                customData: customData,
            } = datapoints.ConversationViewSortOrder.datapoint;

            logUsage(eventName, customData(sortOrderFromOptions));
        }
    } catch (error) {
        trace.errorThatWillCauseAlert('logAfterInitialRender failed : ' + error);
    }
};

export default logDatapointsAfterInitialRender;
